import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Shield, MessageCircle } from 'lucide-react';

const WhistleblowerSectionSv = () => {
  return <section className="py-20 bg-gradient-to-br from-[hsl(var(--focus-areas-start))] via-[hsl(var(--focus-areas-mid))] to-[hsl(var(--focus-areas-end))]">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12">
            <div className="flex justify-center mb-6">

            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
              Hjälp oss förbättra ekosystemet
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Din röst spelar roll. Hjälp oss identifiera vad som inte fungerar i Sveriges startup-ekosystem så att vi kan arbeta tillsammans för att skapa positiv förändring.
            </p>
          </div>

          <Card className="bg-white shadow-xl border-0 mb-8">
            <CardContent className="p-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div className="text-left">
                  <h3 className="text-2xl font-bold mb-4 text-black">Vad fungerar inte?</h3>
                  <p className="text-gray-700 mb-6">
                    Vi är engagerade i transparens och kontinuerlig förbättring. Om du har stött på problem, hinder eller svårigheter inom startup-ekosystemet vill vi höra om det.
                  </p>

                  <div className="space-y-3 mb-6">
                    <h4 className="font-semibold text-gray-900">Vanliga problem inkluderar:</h4>
                    <ul className="space-y-2 text-gray-600">
                      <li>• Diskriminering eller bias i finansieringsprocesser</li>
                      <li>• Regulatoriska hinder och byråkratiska hinder</li>
                      <li>• Orättvisa affärsmetoder</li>
                      <li>• Åtkomsthinder för underrepresenterade grupper</li>
                      <li>• Systemiska problem som påverkar startup-tillväxt</li>
                    </ul>
                  </div>
                </div>

                <div className="text-left">
                  <h3 className="text-2xl font-bold mb-4 text-black">Din integritet är skyddad</h3>
                  <div className="flex items-start space-x-3 mb-4">
                    <Shield className="h-6 w-6 text-blue-600 mt-1" />
                    <div>
                      <h4 className="font-semibold text-gray-900">Fullständig anonymitet</h4>
                      <p className="text-gray-600">Rapporter kan skickas in helt anonymt utan att någon personlig information krävs.</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 mb-4">
                    <MessageCircle className="h-6 w-6 text-blue-600 mt-1" />
                    <div>
                      <h4 className="font-semibold text-gray-900">Konfidentiell granskning</h4>
                      <p className="text-gray-600">Alla rapporter granskas konfidentiellt och används för att förbättra ekosystemets förutsättningar.</p>
                    </div>
                  </div>

                  <div className="p-4 bg-blue-50 rounded-lg">
                    <p className="text-sm text-blue-800 font-medium">
                      Din feedback driver systemiska förändringar och hjälper till att skapa en mer inkluderande, rättvis startup-miljö för alla.
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <Button size="lg" variant="cyan" className="font-semibold px-8 py-3">
                  <AlertTriangle className="w-5 h-5 mr-2" />
                  Rapportera ett problem konfidentiellt
                </Button>
                <p className="text-sm text-gray-500 mt-3">
                  Alla rapporter hanteras med fullständig konfidentialitet och används för att driva positiv förändring.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};
export default WhistleblowerSectionSv;
